module.exports = __webpack_public_path__ + "public/img/chejian.8a9d3f95.png";